import React from 'react';
import Header from "../../components/layout/Header";
import Banner from "../../components/home/Banner";
import Footer from "../../components/layout/Footer";

const Toys = () => {
    const banners = [
        "/toys_hero_new.png",
        "/toys_banner_2.png",
        "/toys_banner_3.png",
    ];

    return (
        <div style={{ backgroundColor: '#f1f2f4', minHeight: '100vh', paddingTop: '128px' }}>
            <Header />
            <div style={{ maxWidth: '1440px', margin: '0 auto', padding: '12px 16px' }}>

                {/* 1. Primary Scrolling Banner */}
                <div style={{ marginBottom: '32px', borderRadius: '24px', overflow: 'hidden', boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)' }}>
                    <Banner images={banners} height="300px" />
                </div>

                {/* 2. Character-based Category Store */}
                <div style={{ marginBottom: '40px' }}>
                    <h2 style={{ fontSize: '22px', marginBottom: '24px', fontWeight: '800' }}>Character & Series Store</h2>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '24px' }}>
                        {[
                            { name: "Superheroes", color: "#fef2f2", img: "/superhero_cat.png" },
                            { name: "Barbie & Dolls", color: "#fdf2f8", img: "https://rukminim1.flixcart.com/fk-p-flap/128/128/image/091396a84c79435b.jpg?q=20" },
                            { name: "Action Figures", color: "#eff6ff", img: "https://rukminim1.flixcart.com/fk-p-flap/128/128/image/489f076e03328e75.jpg?q=20" },
                            { name: "LEGO World", color: "#f7fee7", img: "/lego_cat.png" },
                        ].map((cat, i) => (
                            <div
                                key={i}
                                style={{
                                    backgroundColor: cat.color,
                                    borderRadius: '32px',
                                    padding: '32px',
                                    textAlign: 'start',
                                    cursor: 'pointer',
                                    transition: '0.4s',
                                    border: '1px solid #f0f0f0',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center'
                                }}
                            >
                                <div style={{ width: '120px', height: '120px', backgroundColor: 'white', borderRadius: '50%', boxShadow: '0 1px 2px rgba(0,0,0,0.06)', padding: '16px', border: '2px solid white', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <img src={cat.img} alt={cat.name} style={{ width: '90px', height: '90px', objectFit: 'contain' }} />
                                </div>
                                <div style={{ textAlign: 'start', width: '100%', marginTop: '24px' }}>
                                    <p style={{ fontWeight: '900', fontSize: '18px', color: '#333', margin: 0 }}>{cat.name}</p>
                                    <p style={{ color: '#718096', fontWeight: '700', marginTop: '4px', margin: '4px 0 0 0' }}>Shop Collection &gt;</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* 3. Age-based Navigation */}
                <div style={{ backgroundColor: 'white', padding: '32px', borderRadius: '32px', marginBottom: '48px', boxShadow: '0 1px 2px rgba(0,0,0,0.06)' }}>
                    <h2 style={{ fontSize: '18px', marginBottom: '32px', fontWeight: '800', color: '#666' }}>Shop by Age</h2>
                    <div style={{ display: 'flex', gap: '40px', overflowX: 'auto', paddingBottom: '16px', justifyContent: 'flex-start' }} className="no-scrollbar">
                        {["0-2 Years", "3-5 Years", "6-8 Years", "9-12 Years", "12+ Years"].map((age, i) => (
                            <div key={i} style={{ minWidth: '140px', cursor: 'pointer', textAlign: 'center', transition: '0.3s', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <div style={{ width: '100px', height: '100px', backgroundColor: '#fff5f5', borderRadius: '50%', padding: '16px', border: '2px solid #ffe4e1', boxShadow: '0 4px 6px -1px rgba(0,0,0,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <h3 style={{ fontSize: '20px', color: '#e53e3e', margin: 0 }}>{age.split(' ')[0]}</h3>
                                </div>
                                <p style={{ fontWeight: '800', marginTop: '12px', fontSize: '14px', color: '#333', margin: '12px 0 0 0' }}>{age}</p>
                            </div>
                        ))}
                    </div>
                </div>

                {/* 4. Best Selling Toys Grid */}
                <div style={{ marginBottom: '80px' }}>
                    <h2 style={{ fontSize: '24px', marginBottom: '40px', fontWeight: '900', textAlign: 'start' }}>Kids' Top Favs</h2>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '32px' }}>
                        {[1, 2, 3, 4].map(i => (
                            <div key={i} style={{ backgroundColor: 'white', padding: '24px', borderRadius: '32px', textAlign: 'start', cursor: 'pointer', transition: '0.3s', border: '1px solid #f0f0f0', display: 'flex', flexDirection: 'column' }}>
                                <div style={{ height: '220px', width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '16px' }}>
                                    <img src="/rc_car_cat.png" alt="Toy" style={{ height: '100%', objectFit: 'contain' }} />
                                </div>
                                <span style={{ backgroundColor: '#faf5ff', color: '#6b46c1', padding: '2px 12px', borderRadius: '999px', fontWeight: '800', fontSize: '12px', width: 'fit-content' }}>POPULAR</span>
                                <p style={{ fontWeight: '800', fontSize: '16px', margin: '8px 0 0 0' }}>Remote Control Racing Car</p>
                                <p style={{ color: '#718096', fontSize: '13px', fontWeight: '600', margin: '4px 0 0 0' }}>Rechargeable | High-Speed</p>
                                <div style={{ marginTop: '16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <span style={{ fontWeight: '900', fontSize: '20px' }}>₹1,249</span>
                                    <span style={{ color: '#388e3c', fontWeight: '900', fontSize: '14px' }}>Min. 50% Off</span>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default Toys;

